import React, { useState, useContext } from "react";
import { Form, Label, Input } from "reactstrap";
import { ApiContext } from "../apiContext";
import { FaPlus, FaTrash, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Textarea } from "@mobiscroll/react-lite";
import { imageUpload } from "../ImageUpload";
import { getToken } from "../../auth/AuthService";
import notify from "../../helper/Notify";


const AddForm = ({
  handleSubmit,
  formError,
  getInputValue,
  handleInputChange,
  handleClear,
  accordions,
  updateSource,
  modalData,
  addCase
}) => {
  const [openAccordions, setOpenAccordions] = useState({ 0: true });

  const token = getToken();
    const imgDir = "investor-images";
   const [uploadingStates, setUploadingStates] = useState({});


const handleAccordionChange = (accIndex, field, value) => {
  const updatedAccordions = accordions.map((accordion, i) => {
    if (i !== accIndex) return accordion;
    return {
      ...accordion,
      [field]: value,
    };
  });

  updateSource((prev) => ({
    ...prev,
    accordions: updatedAccordions,
  }));
};

const addAccordion = () => {
  const updatedAccordions = [
    ...accordions,
    {
      title: "",
      documents: [],
    },
  ];

  updateSource((prev) => ({
    ...prev,
    accordions: updatedAccordions,
  }));
};

const deleteAccordion = (accIndex) => {
  const updatedAccordions = [...accordions];
  updatedAccordions.splice(accIndex, 1);

  updateSource((prev) => ({
    ...prev,
    accordions: updatedAccordions,
  }));
};

const addDocument = (accIndex) => {
  const updatedAccordions = [...accordions];
  updatedAccordions[accIndex].documents.push({ name: "", file: null });

  updateSource((prev) => ({
    ...prev,
    accordions: updatedAccordions,
  }));
};


const deleteDocument = (accIndex, docIndex) => {
  const updatedAccordions = [...accordions];
  updatedAccordions[accIndex].documents.splice(docIndex, 1);

  updateSource((prev) => ({
    ...prev,
    accordions: updatedAccordions,
  }));
};



const handleDocumentChange = async (accIndex, docIndex, field, value) => {
  const updatedAccordions = [...accordions];
  const docKey = `${accIndex}-${docIndex}`;

  if (field === "file") {
    const file = value;
    const isPdf = file?.type === "application/pdf" || file?.name.toLowerCase().endsWith(".pdf");
    const maxSizeInBytes = 5 * 1024 * 1024;

    if (!isPdf) {
      notify.error("Only PDF files are allowed.");
      return;
    }

    if (file.size >= maxSizeInBytes) {
      notify.error("File size should not exceed 5MB.");
      return;
    }

    setUploadingStates((prev) => ({ ...prev, [docKey]: true }));

    try {
      const base64 = await readFileAsBase64(file);
      const url = await imageUpload(file.name, base64, imgDir, token);

      updatedAccordions[accIndex].documents[docIndex] = {
        ...updatedAccordions[accIndex].documents[docIndex],
        fileUrl: url,
        fileName: file.name,
      };

      updateSource((prev) => ({
        ...prev,
        accordions: updatedAccordions,
      }));
    } catch (err) {
      console.error("PDF upload failed:", err);
    } finally {
      setUploadingStates((prev) => ({ ...prev, [docKey]: false }));
    }
  } else {
    updatedAccordions[accIndex].documents[docIndex][field] = value;

    updateSource((prev) => ({
      ...prev,
      accordions: updatedAccordions,
    }));
  }
};




// Helper to read file as base64
const readFileAsBase64 = (file) => {

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};


const toggleAccordion = (index) => {
  setOpenAccordions(prevIndex => (prevIndex === index ? null : index));
};

const anyUploading = Object.values(uploadingStates).some((val) => val === true);


  const { error } = useContext(ApiContext);
  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
  <Form onSubmit={handleSubmit}>
  <div className="row edit-form">
    <div className="my-3 col-md-12">
      <Label for="title">Title</Label>
      <Input
        type="text"
        id="title"
        name="title"
        placeholder="Title"
        required
        value={getInputValue("title")}
        onChange={(event) => handleInputChange(event, "title")}
      />
      <span className="non-valid">{formError.title}</span>
    </div>

    <div className="my-3 col-md-12">
      <Label for="description">Description</Label>
      <Textarea
        id="description"
        name="description"
        placeholder="Enter a description"
        required
        value={getInputValue("description")}
        onChange={(event) => handleInputChange(event, "description")}
      />
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <h5>Accordion Sections</h5>
      <button
        type="button"
        className="btn mb-3"
        onClick={addAccordion}
        style={{ background: "#fff", border: "1px solid #ddd" }}
      >
        <FaPlus /> Add Accordion
      </button>
    </div>

    <div className="colm-md-10">
      {accordions?.map((accordion, accIndex) => (
        <div
          className="card p-2 mb-3"
          style={{ borderLeft: "2px solid #526cfe" }}
          key={accIndex}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => toggleAccordion(accIndex)}
          >
            <h5 className="m-0">
              {accordion.title?.trim()
                ? accordion.title
                : `Accordion #${accIndex + 1}`}
            </h5>
            <div>
              <button
                type="button"
                className="btn btn-danger btn-sm me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  deleteAccordion(accIndex);
                }}
              >
                <FaTrash />
              </button>
              <button
                type="button"
                className="btn btn-link btn-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleAccordion(accIndex);
                }}
              >
                {openAccordions === accIndex  ? <FaChevronUp /> : <FaChevronDown />}
              </button>
            </div>
          </div>

          {/* Collapse Body */}
          {openAccordions === accIndex && (
            <div className="mt-3">
              <div className="mb-3">
                <Label>Accordion Title</Label>
                <Input
                  type="text"
                  placeholder="Accordion Title"
                  value={accordion.title}
                  onChange={(e) =>
                    handleAccordionChange(accIndex, "title", e.target.value)
                  }
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6>Documents</h6>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => addDocument(accIndex)}
                >
                  <FaPlus /> Add Document
                </button>
              </div>

              {accordion.documents.map((doc, docIndex) => (
                <div
                  key={docIndex}
                  className="document-wrapper mb-3 p-3"
                  style={{
                    border: "1px solid #dee2e6",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                  }}
                >
                  <div className="row align-items-center">
                    <div className="col-md-11">
                      <Label>Document Name</Label>
                      <Input
                        type="text"
                        placeholder="Document Title"
                        value={doc.name}
                        onChange={(e) =>
                          handleDocumentChange(
                            accIndex,
                            docIndex,
                            "name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-1 mt-4">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteDocument(accIndex, docIndex)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-12">
                      <Label>PDF File (Upload only Pdf upto 5mb)</Label>   
                    <div className="file-field">
              <div className="btn helensys-theme-btn btn-sm ml-0">
                <span>Choose File</span>
                <Input
                  id="documentuplad"
                  name="pdffile"
                  type="file"
                  onChange={(e) =>
                          handleDocumentChange(
                            accIndex,
                            docIndex,
                            "file",
                            e.target.files[0]
                          )
                        }
                  accept="image/pdf*"
                  encType="multipart/form-data"
                />
              </div>
              <div className="file-name-wrapper">
                 <Input
      className="file-path validate"
      type="text"
      placeholder=""
      value={doc.fileName || ""}
      readOnly
    />
   {uploadingStates[`${accIndex}-${docIndex}`] && (
  <p className="text-warning mb-0 mt-2" style={{ fontSize: "0.85rem" }}>
    Uploading, please wait...
  </p>
)}

              </div>
               </div>

                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>

    <div className="my-3 col-md-6">
      <Label for="status">Status</Label>
      <div className="toggle">
        <span>Inactive</span>
        <label
          className={`switch ${
            (modalData?.status || addCase.status) ? "true" : ""
          }`}
        >
          <Input
            type="checkbox"
            checked={modalData?.status || addCase.status}
            onChange={() => {
              updateSource((prev) => ({
                ...prev,
                status: !prev.status,
              }));
            }}
          />
          <span className="slider round"></span>
        </label>
        <span>Active</span>
      </div>
    </div>

    <div className="modal-footer">
      <button
        type="button"
        className="btn btn-warning ms-2"
        onClick={handleClear}
      >
        Clear
      </button>
  <button
  type="button"
  disabled={anyUploading}
  className="btn btn-primary ms-2"
  onClick={handleSubmit}
>
  {anyUploading ? "Uploading..." : "Submit"}
</button>

    </div>
  </div>
</Form>



    </>
  );
};
export default AddForm;
